import { BuildType } from './ApiService';
import { FinancialAidFilters, FinancialAidModel, FinancialAidResponse, QueryFinancialAidParams } from '@/types/FinancialAid';

export const financialAidApiEndpoints = (build: BuildType) => ({
    financialAid: build.query<FinancialAidResponse, QueryFinancialAidParams>({
        query: params => ({
            url: 'financial-aid/query',
            method: 'POST',
            body: params,
        }),
        transformResponse: (response: FinancialAidResponse) => response,
    }),
    financialAidDetails: build.query<FinancialAidModel, string>({
        query: id => `financial-aid/${id}`,
        transformResponse: (response: FinancialAidModel) => response,
    }),
    financialAidFilters: build.query<FinancialAidFilters, void>({
        query: () => 'financial-aid/available-filters',
    }),
    favoriteFinancialAid: build.mutation<void, string>({
        query: id => ({
            url: `user-financial-aids/${id}/favorite`,
            method: 'POST',
        }),
        invalidatesTags: ['Favorites'],
    }),
});
